import { Injectable } from '@angular/core';
import { defer, firstValueFrom, from, Observable } from 'rxjs';

export const CRM_AUTH_REFRESH_LOCK_NAME = 'crm-auth-refresh';

/**
 * Сериализует обновление сессии между вкладками одного origin через Web Locks API.
 *
 * Проблема: localStorage (accessToken/refreshToken) общий для всех вкладок, а
 * refresh-токен на бэкенде РОТИРУЕТСЯ и одноразовый — повторное использование токена,
 * который «отстал» на 2+ ротации, бэкенд считает кражей и отзывает ВСЕ сессии
 * пользователя (разлогин везде). Без координации две вкладки, у которых почти
 * одновременно протух access-токен, шлют /auth/refresh одним и тем же токеном и легко
 * выходят за узкое grace-окно сервера.
 *
 * Решение: под эксклюзивной блокировкой рефреш крутит только одна вкладка; остальные
 * ждут и затем (см. AuthService.refreshUnderCrossTabLock) подхватывают уже
 * ротированный токен из localStorage вместо повторного запроса.
 *
 * Если Web Locks недоступен (старый браузер / небезопасный контекст) — работаем без
 * межвкладочной сериализации, как раньше.
 */
@Injectable({
  providedIn: 'root',
})
export class RefreshLockService {
  runExclusive<T>(work: () => Observable<T>): Observable<T> {
    const lockManager = this.getLockManager();

    if (!lockManager) {
      return defer(work);
    }

    return defer(() =>
      from(lockManager.request(CRM_AUTH_REFRESH_LOCK_NAME, () => firstValueFrom(defer(work))))
    );
  }

  private getLockManager(): LockManager | null {
    if (typeof navigator === 'undefined') {
      return null;
    }

    const lockManager = (navigator as Navigator & { locks?: LockManager }).locks;

    return lockManager && typeof lockManager.request === 'function' ? lockManager : null;
  }
}
